var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "card" },
      [
        _c("div", { staticClass: "typeHeader LR_center" }, [
          _c(
            "div",
            [
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  staticStyle: { width: "314px" },
                  attrs: {
                    placeholder: _vm.addPls(
                      "i18n_Product_name_in_Chinese",
                      "input"
                    ),
                    clearable: ""
                  },
                  on: {
                    clear: function($event) {
                      return _vm.getgoodsData()
                    }
                  },
                  model: {
                    value: _vm.name,
                    callback: function($$v) {
                      _vm.name = $$v
                    },
                    expression: "name"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "append",
                        icon: "el-icon-search",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.getgoodsData(true)
                        }
                      },
                      slot: "append"
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_Search")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-plus", plain: "" },
                  on: {
                    click: function($event) {
                      return _vm.addgoods()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_New_Products")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-download",
                    plain: ""
                  },
                  on: {
                    click: function($event) {
                      _vm.excelVisible = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_Importing_Products")))]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "countTable", staticStyle: { "margin-top": "30px" } },
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.goodsLabel,
                  "tooltip-effect": "dark"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("i18n_Product_name_in_Chinese"),
                    align: "center",
                    width: "120"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_vm._v(_vm._s(scope.row.namec))]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "namee",
                    label: _vm.$t("i18n_product_name_in_English"),
                    align: "center",
                    width: "120"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "country",
                    align: "center",
                    label: _vm.$t("i18n_Country")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "goodstype",
                    align: "center",
                    label: _vm.$t("i18n_cargo_classification")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "materialc",
                    align: "center",
                    label: _vm.$t("i18n_Material_in_Chinese")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "purposec",
                    align: "center",
                    label: _vm.$t("i18n_Uses")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "hsCode",
                    align: "center",
                    label: _vm.$t("i18n_HTS_code")
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("i18n_electric_or_not"),
                    align: "center",
                    width: "120"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  scope.row.isHasBattery
                                    ? "i18n_yes"
                                    : "i18n_no"
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("i18n_liquid_power_or_not"),
                    align: "center",
                    width: "120"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  scope.row.isPowderLiquid
                                    ? "i18n_yes"
                                    : "i18n_no"
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("i18n_Operation"),
                    align: "center",
                    width: "120"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.goodsEdit(scope.$index, scope.row)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_edit")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "red" },
                              attrs: { size: "mini", type: "text" },
                              on: {
                                click: function($event) {
                                  return _vm.delGoodItem(
                                    scope.$index,
                                    scope.row
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_delete")))]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block", staticStyle: { "margin-top": "20px" } },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.totalPage
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.$t("i18n_Create_new_product"),
              "before-close": _vm.close,
              visible: _vm.goodstextShow,
              width: "850px"
            },
            on: {
              "update:visible": function($event) {
                _vm.goodstextShow = $event
              }
            }
          },
          [
            _c(
              "div",
              { staticStyle: { width: "100%", margin: "0 20px" } },
              [
                _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("i18n_Country_shipment_type")))
                ]),
                _vm._v(" "),
                _c("el-cascader", {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { size: "small", options: _vm.countryList },
                  on: { change: _vm.MyhandleChange },
                  model: {
                    value: _vm.countryId,
                    callback: function($$v) {
                      _vm.countryId = $$v
                    },
                    expression: "countryId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { width: "100%", margin: "20px 0" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "addgoodform",
                    staticClass: "LR_center",
                    attrs: {
                      size: "small",
                      model: _vm.addgoodform,
                      "label-width": "110px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "45%" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              label: _vm.$t("i18n_Product_name_in_Chinese"),
                              rules: {
                                required: true,
                                message: "中文品名不能为空",
                                trigger: "blur"
                              }
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.namec,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "namec", $$v)
                                },
                                expression: "addgoodform.namec"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { label: _vm.$t("i18n_brands") }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.brand,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "brand", $$v)
                                },
                                expression: "addgoodform.brand"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { label: _vm.$t("i18n_HTS_code") }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.hsCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "hsCode", $$v)
                                },
                                expression: "addgoodform.hsCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { label: _vm.$t("i18n_Material_in_Chinese") }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.materialc,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "materialc", $$v)
                                },
                                expression: "addgoodform.materialc"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              label: _vm.$t("i18n_Product_uses_in_Chinese")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.purposec,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "purposec", $$v)
                                },
                                expression: "addgoodform.purposec"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              rules: {
                                required: true,
                                message: "是否液体/粉末",
                                trigger: "change"
                              },
                              label: _vm.$t("i18n_electric_or_not")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("i18n_please_choose")
                                },
                                model: {
                                  value: _vm.addgoodform.isHasBattery,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addgoodform,
                                      "isHasBattery",
                                      $$v
                                    )
                                  },
                                  expression: "addgoodform.isHasBattery"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("i18n_yes"),
                                    value: true
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("i18n_no"),
                                    value: false
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { width: "45%" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              label: _vm.$t("i18n_product_name_in_English"),
                              rules: {
                                required: true,
                                message: "英文品名不能为空",
                                trigger: "blur"
                              }
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.namee,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "namee", $$v)
                                },
                                expression: "addgoodform.namee"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { label: "SKU" }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.sku,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "sku", $$v)
                                },
                                expression: "addgoodform.sku"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("i18n_product_value") } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "275px" },
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter"),
                                type: "number"
                              },
                              model: {
                                value: _vm.addgoodform.declaredValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addgoodform,
                                    "declaredValue",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "addgoodform.declaredValue"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { label: _vm.$t("i18n_material_in_English") }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.materiale,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "materiale", $$v)
                                },
                                expression: "addgoodform.materiale"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              label: _vm.$t("i18n_Product_uses_in_English")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t("i18n_please_enter")
                              },
                              model: {
                                value: _vm.addgoodform.purposee,
                                callback: function($$v) {
                                  _vm.$set(_vm.addgoodform, "purposee", $$v)
                                },
                                expression: "addgoodform.purposee"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              rules: {
                                required: true,
                                message: "是否液体/粉末",
                                trigger: "change"
                              },
                              label: _vm.$t("i18n_liquid_power_or_not")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("i18n_please_choose")
                                },
                                model: {
                                  value: _vm.addgoodform.isPowderLiquid,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addgoodform,
                                      "isPowderLiquid",
                                      $$v
                                    )
                                  },
                                  expression: "addgoodform.isPowderLiquid"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("i18n_yes"),
                                    value: true
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: _vm.$t("i18n_no"),
                                    value: false
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "TB_center",
                    staticStyle: {
                      width: "100%",
                      padding: "30px",
                      "box-sizing": "border-box"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.addgoodtext("addgoodform")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.GoodsCategory
                              ? _vm.$t("i18n_confirm_addition")
                              : _vm.$t("i18n_confirm_revision")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "文件上传",
              visible: _vm.excelVisible,
              width: "70%",
              center: ""
            },
            on: {
              "update:visible": function($event) {
                _vm.excelVisible = $event
              }
            }
          },
          [
            _c(
              "el-upload",
              {
                staticClass: "upload-demo",
                staticStyle: { "text-align": "center" },
                attrs: {
                  "show-file-list": false,
                  "on-error": _vm.handleError,
                  "on-success": _vm.handleSuccess,
                  "before-upload": _vm.handleBeforeUpload,
                  drag: "",
                  "http-request": _vm.uploadSectionFile,
                  action: "",
                  multiple: ""
                }
              },
              [
                _c("i", { staticClass: "el-icon-upload" }),
                _vm._v(" "),
                _c("div", { staticClass: "el-upload__text" }, [
                  _vm._v(_vm._s(_vm.$t("i18n_Drag_file_here_or"))),
                  _c("em", [_vm._v(_vm._s(_vm.$t("i18n_click_Upload")))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "el-upload__tip",
                    attrs: { slot: "tip" },
                    slot: "tip"
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_xls_and_xlsx_only")))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-right": "20px" },
                    attrs: { size: "mini" },
                    on: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "success" },
                    on: { click: _vm.donwLoadTemplate }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_Download_Template")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.resultList.length
              ? _c(
                  "el-table",
                  {
                    staticStyle: { "margin-top": "20px", width: "100%" },
                    attrs: { data: _vm.resultList, border: "" }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "lineNumber",
                        label: _vm.$t("i18n_Number_of_rows"),
                        width: "180"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "isSuccess",
                        label: _vm.$t("i18n_Is_it_successful"),
                        width: "180"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        scope.row.isSuccess
                                          ? "i18n_Success"
                                          : "i18n_Failure"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2707800915
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "failureReason",
                        label: _vm.$t("i18n_Description")
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-394296f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394296f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/FBAheader/FbaGoodsBase.vue
// module id = null
// module chunks = 